(() => {
  const initCollectionTabs = (section) => {
    if (!section || section.dataset.collectionTabsInitialized === "true") return;

    const buttons = Array.from(section.querySelectorAll("[data-collection-tab-button]"));
    const panels = Array.from(section.querySelectorAll("[data-collection-tab-panel]"));

    if (!buttons.length || buttons.length !== panels.length) return;

    const activateTab = (index) => {
      buttons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === index;
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      buttons[index].scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    };

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => activateTab(index));
    });

    const carousels = Array.from(section.querySelectorAll("[data-collection-carousel]"));
    carousels.forEach((carousel) => {
      carousel.addEventListener(
        "wheel",
        (event) => {
          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            carousel.scrollLeft += event.deltaY;
            event.preventDefault();
          }
        },
        { passive: false }
      );
    });

    const enableDragScroll = (element) => {
      if (!element) return;

      let isPointerDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      element.addEventListener("pointerdown", (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        isPointerDown = true;
        startX = event.clientX;
        startScrollLeft = element.scrollLeft;
        element.classList.add("is-dragging");
      });

      element.addEventListener("pointermove", (event) => {
        if (!isPointerDown) return;
        const delta = event.clientX - startX;
        element.scrollLeft = startScrollLeft - delta;
        event.preventDefault();
      });

      const stopDragging = () => {
        isPointerDown = false;
        element.classList.remove("is-dragging");
      };

      element.addEventListener("pointerup", stopDragging);
      element.addEventListener("pointerleave", stopDragging);
      element.addEventListener("pointercancel", stopDragging);
    };

    enableDragScroll(section.querySelector(".collection-tabs__menu"));
    carousels.forEach((carousel) => enableDragScroll(carousel));

    activateTab(0);
    section.dataset.collectionTabsInitialized = "true";
  };

  const initAll = () => {
    document.querySelectorAll("[data-collection-tabs]").forEach((section) => initCollectionTabs(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
